/**
 * This will return sum of the array items
 */
export const sumArrayItems = (array: number[]) => array?.reduce((sum, val) => sum + val, 0);
